export default __webpack_public_path__ + "assets/dust-day.4677c89e.svg";